import * as React from 'react';
import { useIsExploreUser } from 'hooks/client';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

type Props = {
    viewIndicators: () => void;
    disabled: boolean;
};

const CellarViewIndicators = ({ viewIndicators, disabled }: Props) => {
    const { t } = useTranslation();
    const isExploreUser = useIsExploreUser();
    return isExploreUser ? (
        <div className="see-explore">
            <Button
                className="e2e-view-field-button"
                onClick={viewIndicators}
                disabled={disabled}
            >
                {t('common.view')}
            </Button>
        </div>
    ) : (
        <></>
    );
};

export default CellarViewIndicators;
